import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var c=create(a);

export { c as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LL2YX4YZ.mjs.map